import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "react-bootstrap";

import { fetchConflictMatches } from "./ConflictCheckResults.service";
import { COI_CONFLICT_STATUS, COIClientSummary, COIConflictMatch, ConflictCheckResultsProps } from "./ConflictCheckResults.types";
import { resolvePageIds } from "./ConflictCheckResults.utils";
import ClientApprovalWizard from "../../client_onboarding/ClientApprovalWizard/ClientApprovalWizard";
import { ClientRecord } from "../../client_onboarding/ClientsGrid/ClientsGrid.utils";
import styles from "./ConflictCheckResults.module.css";

const ConflictCheckResults: React.FC<ConflictCheckResultsProps & { pageOption?: { clientMasterId?: number; processedTemplateId?: number } }> = (
  props
) => {
  const { transporter } = props;
  const { clientMasterId, processedTemplateId } = useMemo(() => resolvePageIds(props.pageOption), [props.pageOption]);

  const [clientSummary, setClientSummary] = useState<COIClientSummary>();
  const [matches, setMatches] = useState<COIConflictMatch[]>();
  const [canDecide, setCanDecide] = useState(false);
  const [matchesLoading, setMatchesLoading] = useState(true);

  useEffect(() => {
    if (!clientMasterId) return;
    setMatchesLoading(true);
    fetchConflictMatches(clientMasterId, processedTemplateId)
      .then(({ matches: fetched, clientSummary: summary, canDecide: decideAllowed }) => {
        setMatches(fetched);
        setClientSummary(summary);
        setCanDecide(decideAllowed);
      })
      .catch((err) => console.error(err))
      .finally(() => setMatchesLoading(false));
  }, [clientMasterId, processedTemplateId]);

  const goBack = () => {
    if (!transporter) return;
    transporter(processedTemplateId ? "approval_details" : "client_approval");
  };

  if (!clientMasterId) {
    return (
      <Row className={styles.emptyState}>
        <Col>A client is required to view Conflict Check results.</Col>
      </Row>
    );
  }

  const clientRecord = {
    COIApprovalStatus: COI_CONFLICT_STATUS,
    BusinessUnit: clientSummary?.LineOfService,
  } as ClientRecord;

  return (
    <ClientApprovalWizard
      show
      onHide={goBack}
      transporter={transporter}
      coiReviewMode
      coiMatches={matches}
      coiCanDecide={canDecide}
      coiMatchesLoading={matchesLoading}
      clientMasterId={clientMasterId}
      processedTemplateId={processedTemplateId}
      attestFormId={Number(clientSummary?.AttestFormId) || 0}
      onboardingFormId={Number(clientSummary?.OnboardingFormId) || 0}
      taxAcceptanceFormId={0}
      auditAcceptanceFormId={0}
      firmDetailId={0}
      clientRecord={clientRecord}
      rejectOptions={{}}
      refresh={() => {}}
    />
  );
};

export default ConflictCheckResults;
